import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextBoxMultiCarFilter from '../../UserControl/TextBoxMultiCarFilter/TextBoxMultiCarFilter';
import DateTimeRange from '../../UserControl/DateTimeRange/DateTimeRange';
import {getMonthTHFromInt,getMainCookie,checkStatus} from '../../../../util/util';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';

var user_id = "";
var user_name = "";
var token = "";


var selectCarList=[];
var startDate=null;
var endDate=null;

class ViewTemporary extends Component {
    constructor() {
        super();
        this.state  = {
            flashList:[],
            selectCarList:[],
            selectDateRange:[],
            isNewCarTags:false,
            isEditCarTags:false
        };
    }

    componentDidMount(){
        let main = getMainCookie();
        user_id = main.user_id;
        user_name = main.login_name;
        token = main.token;
        this.getFlash(1,500);
        
    }
    componentWillUnmount(){
        this.setState({
            flashList: []
        })

    }
    setMultiCar(tags){
        console.log("tag",tags);
        selectCarList=tags;
    }
    setRangeDate(sDate,eDate){
        startDate=sDate;
        endDate=eDate;
        if(sDate && eDate && sDate!=null && eDate!=null){
            startDate=sDate.toObject();
            endDate=eDate.toObject();
        }
        console.log("setRangeDate",startDate,endDate);
    }

    getFlash(pageNumber,pageSize){
        let currentComponent = this;
        console.log("getFlash",user_id,user_name,token)
        fetch(this.props.url+"/"+pageNumber+"/"+pageSize, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",

                // "user_id":user_id,
                // "user_name":user_name,
                "token":token
                }
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            console.log('Created Gist:', data);
            if(data.RESULT_DATA){
                currentComponent.setState({
                    flashList: data.RESULT_DATA
                })

            }

        });
    }


    newFlash(){
        endDate=null;
        startDate=null;
        selectCarList=[];
        this.refs.txtNewFlash_remark.value="";
        this.refs.dvNewAlert.innerHTML="";
        this.setState({
            selectCarList: selectCarList,
            selectDateRange:{
                startDate:startDate,
                endDate:endDate},
            isNewCarTags:true
        });
    }

    editeFlash(flash){
        this.refs.dvEditAlert.innerHTML="";
        let sDate=flash.start_date.split('-')[2]+'/'+flash.start_date.split('-')[1]+'/'+flash.start_date.split('-')[0];
        let eDate=flash.end_date.split('-')[2]+'/'+flash.end_date.split('-')[1]+'/'+flash.end_date.split('-')[0];
        console.log(sDate,eDate);
        endDate=null;
        startDate=null;
        selectCarList=[];
        this.setState({
            selectCarList: flash.cars,
            selectDateRange:{
                startDate:sDate,
                endDate:eDate},
            isEditCarTags:true
        });
        this.refs.txtFlashID.value=flash.flash_view_cd;
        this.refs.txtEditFlash_flash_view_cd.value=flash.flash_view_cd;

        this.refs.txtEditFlash_remark.value=flash.remarks;

    }
    closeEdit(){
        this.setState({
            isEditCarTags:false
        });
    }
    closeNew(){
        this.setState({
            isNewCarTags:false
        });
    }
    deleteFlash(flash){
        this.refs.txtDelTitle.innerHTML=flash.flash_view_cd;
        this.refs.txtFlashID.value=flash.flash_view_cd;
        let currentComponent = this;
        AlertConfirm("ลบการเข้าดู","คุณต้องการลบ <b style='color:red'>"+flash.flash_view_cd+"</b>").then(isOk=>{
            if(isOk){
                fetch(this.props.url.replace("getFlashViewList","deleteFlashView/")+ flash.flash_view_cd , {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
        
                        // "user_id":user_id,
                        // "user_name":user_name,
                        "token":token
                        },
                    body: JSON.stringify({})
                }).then(function(response) {
                    return checkStatus(response);
                }).then(function(data) {
                    console.log(data,"data")
                    currentComponent.btnDelClose.click();
                    currentComponent.getFlash(1,500);
                    if(data.RESULT_STATUS == "000")
                        AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                    else{
                        AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                    }
                });
            }
            
        });
    }
    callNewFlash(){
        let currentComponent = this;
        this.refs.dvNewAlert.innerHTML="";
        if(endDate === null || startDate===null || selectCarList.length===0){
            this.refs.dvNewAlert.innerHTML="กรุณาใส่ข้อมูลรถและช่วงวัน";
            return ;
        }

        let sMM=(startDate.months+1).toString();
        let eMM=(endDate.months+1).toString();
        let sDD=(startDate.date).toString();
        let eDD=(endDate.date).toString();
        if(sMM.length === 1)
            sMM ="0"+sMM;
        if(eMM.length === 1)
            eMM ="0"+eMM;
        if(sDD.length === 1)
            sDD ="0"+sDD;
        if(eDD.length === 1)
            eDD ="0"+eDD;
        fetch(this.props.url.replace("getFlashViewList","newFlashView"), {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",

                // "user_id":user_id,
                // "user_name":user_name,
                "token":token
                },
            body: JSON.stringify(
                {
                    //"flash_view_cd" : "1234",
                    "cars" : selectCarList,
                    "start_date" :sDD + "-" + sMM+ "-" + startDate.years,
                    "start_time" : "00:00",
                    "end_date" :eDD + "-" + eMM+ "-" + endDate.years,
                    "end_time" : "23:59",
                    "remarks" : this.refs.txtNewFlash_remark.value
                }
            )
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            currentComponent.btnNewClose.click();
            currentComponent.getFlash(1,500);

        });
        this.setState({
            isNewCarTags:false
        });
    }
    callEditFlash(){
        let currentComponent = this;
        console.log('callEditFlash',startDate,endDate,selectCarList)
        this.refs.dvEditAlert.innerHTML="";
        if(endDate === null || startDate===null || selectCarList.length===0){
            console.log('callEditFlash  aaa')
            this.refs.dvEditAlert.innerHTML="กรุณาใส่ข้อมูลรถและช่วงวัน";
            return ;
        }
        console.log('callEditFlash  bbb')
        let sMM=(startDate.months+1).toString();
        let eMM=(endDate.months+1).toString();
        let sDD=(startDate.date).toString();
        let eDD=(endDate.date).toString();
        if(sMM.length === 1)
            sMM ="0"+sMM;
        if(eMM.length === 1)
            eMM ="0"+eMM;
        if(sDD.length === 1)
            sDD ="0"+sDD;
        if(eDD.length === 1)
            eDD ="0"+eDD;
        console.log(sDD + "-" + sMM + "-" + startDate.years,eDD + "-" + eMM+ "-" + endDate.years)
        fetch(this.props.url.replace("getFlashViewList","updateFlashView/")+ this.refs.txtFlashID.value , {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",

                // "user_id":user_id,
                // "user_name":user_name,
                "token":token
                },
            body: JSON.stringify(
                {
                    "cars" : selectCarList,
                    "start_date" :sDD + "-" + sMM+ "-" + startDate.years,
                    "start_time" : "00:00",
                    "end_date" :eDD + "-" + eMM+ "-" + endDate.years,
                    "end_time" : "23:59",
                    "remarks" : this.refs.txtEditFlash_remark.value
                }
            )
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            currentComponent.btnEditClose.click();
            currentComponent.getFlash(1,500);

        });
        this.setState({
            isEditCarTags:false
        });
    }
    callDeleteFlash(){
        let currentComponent = this;
        fetch(this.props.url.replace("getFlashViewList","deleteFlashView/")+ this.refs.txtFlashID.value , {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",

                // "user_id":user_id,
                // "user_name":user_name,
                "token":token
                },
            body: JSON.stringify({})
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            currentComponent.btnDelClose.click();
            currentComponent.getFlash(1,500);

        });
    }
    setDateToBudStr(strDate){
        return strDate.split('-')[0] + ' ' + getMonthTHFromInt(strDate.split('-')[1])+' '+(parseInt(strDate.split('-')[2])+543);
    }

    render() {
        const {flashList,selectCarList,isNewCarTags,isEditCarTags,selectDateRange}=this.state;
        console.log('render',selectDateRange.startDate);
        let rows = [];
        let index=0;
        flashList.map((flash,r)=>{
            index++;
            let rCar=[];
            let pmCars = new Promise(function(resolve, reject) {
                    flash.cars.map((car,c)=>{
                        rCar.push(<span key={car.device_no} className="badge badge-primary">{car.device_no}</span>);
                        if(flash.cars.length-1 === c)
                            resolve("then");
                    })
                }
            )
            pmCars.then(
                rows.push(
                    <tr className="odd gradeX" key={`id_${index}`}>
                        <td>{index}</td>
                        <td>
                            <button type="button"
                                className="btn btn-default btn-block btn-xs btn-flashview-copy">
                                <span data-map="code">{flash.flash_view_cd}</span>
                            </button>
                        </td>
                        <td>

                        {
                            rCar
                        }

                        </td>
                        {/* <td>{flash.start_date} , {flash.start_time} - {flash.end_date} , {flash.end_time}</td> */}
                        <td style={{textAlign:"center"}}>{this.setDateToBudStr(flash.start_date)}  - {this.setDateToBudStr(flash.end_date)} </td>
                        <td style={{wordBreak:'break-word'}}>
                            {flash.remarks}
                        </td>
                        <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Edit">
                            <button onClick={this.editeFlash.bind(this, flash)} className="btn btn-info btn-xs" data-title="Edit" data-toggle="modal" data-target="#editFlash"  data-backdrop="static" data-keyboard="false"><span className="fa fa-pencil" /></button></p>
                        </td>
                        <td ><p data-placement="top" data-toggle="tooltip" title="Delete">
                            <button onClick={this.deleteFlash.bind(this,flash)} className="btn btn-danger btn-xs" data-title="Delete" data-toggle="modal" ><span className="fa fa-trash" /></button></p>
                        </td>
                    </tr>
                )

            )

        });

        return (
            <div className="gray-panel">

                <div className="col-md-12">
                    <h1 className="page-header"> <i className="	fa fa-low-vision" style={{ color: '#7386D5' }} />ดูชั่วคราว</h1>
                </div>

                <div className="col-md-12 table-responsive">

                    {/* <div className="form-inline form-group">
                        <div className="col-md-1">
                            <label htmlFor="focusedInput" className="col-form-label">ค้นหา</label>
                        </div>
                        <div className="col-md-10">
                            <input className="form-control" id="focusedInput" type="text" />
                        </div>



                    </div> */}




                    <table className="table table-bordred table-striped table-hover  "  >
                        <thead style={{textAlign:'center'}}>
                            <tr>
                                <th>#</th>
                                <th>รหัสเข้าดู</th>
                                <th>รถ</th>
                                <th style={{minWidth:100}}>ช่วงเวลา</th>
                                <th>หมายเหตุ</th>
                                <th style={{textAlign:'right'}}>
                                    <button onClick={this.newFlash.bind(this)}  className="btn btn-primary btn-xs" data-title="Add" data-toggle="modal" data-target="#newFlash"><span className="fa fa-plus" /></button>
                                </th>
                                <th></th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                        {rows}

                        </tbody>
                    </table>


                </div>
                <div className="modal fade" id="newFlash" tabIndex={-1} role="dialog" aria-labelledby="newFlash" aria-hidden="true">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading"> รายละเอียดการเข้าดู</h4>
                                <button ref={input => this.btnNewClose = input} onClick={this.closeNew.bind(this)} type="button" className="close" style={{ padding: 0, margin: 0 }} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                            </div>
                            <div className="modal-body">

                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">รถ</label>
                                    <div className="col-md-9">
                                    { isNewCarTags &&
                                        <TextBoxMultiCarFilter
                                            onChange={this.setMultiCar.bind(this)}
                                        />
                                    }
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">ดูช่วงวันที่</label>

                                    <div className="col-md-9">
                                        <div className="input-group date" id="datetimepicker1">
                                        { isNewCarTags &&
                                            <DateTimeRange onSelectDate={this.setRangeDate.bind(this)}/>
                                        }
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">หมายเหตุ</label>
                                    <div className="col-md-9">
                                        <textarea ref="txtNewFlash_remark" className="form-control" id="example-text-input" rows={3} defaultValue={""} />
                                    </div>
                                </div>
                                <div ref="dvNewAlert" className='textAlert'></div>
                            </div>
                            <div className="modal-footer ">
                                <button  onClick={this.callNewFlash.bind(this)} type="button" className="btn btn-primary btn-lg" style={{ width: '100%' }} ><span className="fa fa-check" />&nbsp;เพิ่ม</button>
                            </div>
                        </div>
                        {/* /.modal-content */}
                    </div>
                </div>

                <div className="modal fade" id="editFlash" tabIndex={-1} role="dialog" aria-labelledby="editFlash" aria-hidden="true">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading"> รายละเอียดการเข้าดู</h4>
                                <button ref={input => this.btnEditClose = input} onClick={this.closeEdit.bind(this)} type="button" className="close" style={{ padding: 0, margin: 0 }} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">รหัสเข้าดู
                                    </label>
                                    <div className="col-md-9">
                                        <input ref="txtEditFlash_flash_view_cd" className="form-control" type="text" disabled />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">รถ</label>
                                    <div className="col-md-9">
                                        {/* <input ref="txtEditFlash_cars" className="form-control" type="text"   /> */}
                                       { isEditCarTags &&
                                        <TextBoxMultiCarFilter
                                            onChange={this.setMultiCar.bind(this)}
                                            selecttags={
                                                selectCarList
                                                }

                                        />}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">ดูช่วงวันที่</label>
                                    <div className="col-md-9">
                                        <div className="input-group date" id="datetimepicker1">
                                    { isEditCarTags &&
                                    <DateTimeRange onSelectDate={this.setRangeDate.bind(this)}
                                    initialStartDate={selectDateRange.startDate}
                                    initialEndDate={selectDateRange.endDate}/>
                                    }
                                        </div>
                                    </div>
                                    
                                </div>

                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">หมายเหตุ</label>
                                    <div className="col-md-9">
                                        <textarea ref="txtEditFlash_remark" className="form-control" id="example-text-input" rows={3} defaultValue={""} />
                                    </div>
                                </div>
                                <div ref="dvEditAlert" className='textAlert'></div>
                            </div>
                            <div className="modal-footer ">
                                <button  onClick={this.callEditFlash.bind(this)} type="button" className="btn btn-primary btn-lg" style={{ width: '100%' }} ><span className="fa fa-check" />&nbsp;แก้ไข</button>
                            </div>
                        </div>
                        {/* /.modal-content */}
                    </div>
                </div>
                <div className="modal fade " id="deleteFlash" tabIndex={-1} role="dialog" aria-labelledby="delete" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title custom_align" id="Heading">ลบการเข้าดู</h4>
                            <button type="button" className="close" style={{padding:0,margin:0}} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                        </div>
                        <div className="modal-body">
                            <div className="alert alert-danger"><span className="fa fa-warning" /> คุณต้องการลบ &nbsp;
                            <span style={{fontWeight:'bold'}} ref="txtDelTitle"></span>

                            </div>
                        </div>
                        <div className="modal-footer ">
                            <button type="button" className="btn btn-primary" onClick={this.callDeleteFlash.bind(this)}><span className="fa fa-check" />&nbsp;ตกลง</button>
                            <button ref={input => this.btnDelClose = input}  type="button" className="btn btn-danger" data-dismiss="modal"><span className="fa fa-times" />&nbsp;ยกเลิก</button>
                        </div>
                        </div>
                        {/* /.modal-content */}
                    </div>
                    {/* /.modal-dialog */}
                </div>
                <input type="hidden" ref="txtFlashID" />
            </div>

        );
    }
}
ViewTemporary.propTypes = {
    url: PropTypes.string,

};
ViewTemporary.defaultProps = {
    url: 'http://203.150.199.244/api/admin/getFlashViewList'
};
export default ViewTemporary;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/ViewTemporary.js